import React from 'react'

import HeaderIcon from './HeaderIcon'
import UserProfile from './UserProfile'
import CartDropdown from './CartDropdown'
import WishlistDropdown from './WishlistDropdown'
import CustomCart from 'components/Icons/customCart'
import CustomWishlist from 'components/Icons/customWishlist'

const HeaderActions = ({
  isMobile = false,
  wishlistRef,
  cartRef,
  wishlistCount,
  cartCount,
  isWishlistOpen,
  isCartOpen,
  onWishlistToggle,
  onCartToggle,
  onWishlistClose,
  onCartClose,
}) => {
  const iconSize = isMobile ? 18 : 27

  const content = (
    <div className="flex items-center gap-2 md:gap-0">
      <div ref={wishlistRef} className="relative">
        <HeaderIcon
          isMobile={isMobile}
          icon={CustomWishlist}
          count={wishlistCount}
          iconProps={{ height: iconSize, width: iconSize, strokeWidth: 1.4 }}
          onClick={onWishlistToggle}
        />
        <WishlistDropdown open={isWishlistOpen} onClose={onWishlistClose} />
      </div>
      <div ref={cartRef} className="relative">
        <HeaderIcon
          isMobile={isMobile}
          icon={CustomCart}
          count={cartCount}
          iconProps={{ width: iconSize, height: iconSize, strokeWidth: 1.4 }}
          onClick={onCartToggle}
        />
        <CartDropdown open={isCartOpen} onClose={onCartClose} />
      </div>
    </div>
  )

  if (isMobile) {
    return (
      <div className="flex items-center gap-2">
        <div className="flex items-center gap-1">{content}</div>
        <UserProfile isMobile />
      </div>
    )
  }

  return (
    <div className="flex items-center gap-6">
      {content}
      <UserProfile />
    </div>
  )
}

export default HeaderActions
